import { toQueryString } from '@browsing/utils';

import { toRelativeUrl } from './uri';

export function buildCampaignUrl(campaignIdentifier: string, categoryTabId?: string) {
    if (categoryTabId) {
        return `/campaigns/${campaignIdentifier}/${categoryTabId}`;
    }

    return `/campaigns/${campaignIdentifier}`;
}

/**
 * Builds a direct URL for a given campaign and a set of categories.
 * @param {string} campaignIdentifier
 * @param {string[]} categoryIds
 * @param {object} filter Filter query for colors and prices.
 * @param {string} key Secret campaign key.
 */
export function buildCategoryUrl(
    campaignIdentifier: string,
    categoryIds: Array<string | number>,
    filter: Record<string, string | number> = null,
    key: string | number = null,
) {
    if (key) {
        filter = { ...filter, key };
    }

    // it's ok to have a null filter here
    const query = toQueryString(filter);

    return toRelativeUrl(
        `/campaigns/${campaignIdentifier}/categories/${categoryIds.join(',')}`,
        query,
    );
}
